import { render, staticRenderFns } from "./SingleTeamProfile.vue?vue&type=template&id=a474a570&scoped=true"
import script from "./SingleTeamProfile.vue?vue&type=script&lang=js"
export * from "./SingleTeamProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a474a570",
  null
  
)

export default component.exports